"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var getClassNames = (function (styles, className) {
    return {
        root: styling_1.mergeStyles("sync-overlay", styles.root, className),
        content: styling_1.mergeStyles("sync-overlay-content", styles.content)
    };
});
exports.getClassNames = getClassNames;
